import { TDeviceType } from '@cian/ui-kit/types';

import { getSlidesPerView } from './getSlidesPerView';

export const shouldShowCarouselArrows = (itemsCount: number, device: TDeviceType): boolean => {
  if (device === 'phone') {
    return false;
  }

  return itemsCount > getSlidesPerView(device);
};
